import { render } from "./DetailImage.vue?vue&type=template&id=72d06089&scoped=true"
import script from "./DetailImage.vue?vue&type=script&lang=js"
export * from "./DetailImage.vue?vue&type=script&lang=js"

import "./DetailImage.vue?vue&type=style&index=0&id=72d06089&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d06089"]])

export default __exports__